module.exports = __webpack_public_path__ + "assets/img/picp4-wh7.7a3356be.png";